import React, { createContext, useContext, useState } from 'react';

const FrequencyContext = createContext();

export const useFrequency = () => useContext(FrequencyContext);

export const FrequencyProvider = ({ children }) => {
    // Current Frequency State
    // id: 'root' | photographer_id
    // videoUrl: url string | null
    // label: 'PARADISE FM' | Photographer Name
    const [frequency, setFrequency] = useState({
        id: 'root',
        videoUrl: null, // Null means play default/playlist
        label: 'PARADISE FM',
        channelNumber: null
    });

    // Tuning State (for Static Transition)
    const [isTuning, setIsTuning] = useState(false);

    // Tune Function
    const tuneTo = (id, videoUrl, label, channelNumber = null) => {
        // Don't retune if already on the same frequency
        if (frequency.id === id) return;

        console.log(`[Frequency] Tuning to: ${label} (${id})`);

        // 1. Trigger Static
        setIsTuning(true);

        // 2. Change Channel mid-static (400ms)
        setTimeout(() => {
            setFrequency({
                id,
                videoUrl,
                label,
                channelNumber
            });
        }, 400);

        // 3. Clear Static (800ms)
        setTimeout(() => {
            setIsTuning(false);
        }, 800);
    };

    const value = {
        frequency,
        isTuning,
        tuneTo
    };

    return (
        <FrequencyContext.Provider value={value}>
            {children}
        </FrequencyContext.Provider>
    );
};
